<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card title="面试基本信息">
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="basicInfo.nickname"
              label="姓名"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="房间状态"
              v-model="roomStatus"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="开始时间"
              v-model="basicInfo.startTime"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="结束时间"
              v-model="basicInfo.endTime"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="视频录制"
              v-model="basicInfo.recordPath"
              disabled
            />
          </div>
        </div>
      </va-card>
    </div>

    <div class="flex xs10 offset--xs1">
      <va-card title="对话内容">
        <div class="row">
          <div class="flex xs12">
            <va-input
              label="对话数据"
              v-model="conversation"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>

          <div class="flex xs12">
            <va-button @click="toggleJsonShow" class="mb-2">
              {{ showJson ? '收起 对话结构' : '展开 对话结构' }}
            </va-button>
            <vue-json-pretty
              v-if="showJson"
              :data="parsedConversationList"
              :show-line-number="true"
              :show-double-quotes="false"
              :deep="3"
            />
          </div>
        </div>
      </va-card>
    </div>

    <div class="flex xs10 offset--xs1">
      <va-card title="最新面试设置">
        <div class="row">
          <div class="flex  xs12">
            <va-input
              v-model="preference.position"
              label="岗位"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              v-model="preference.stages"
              label="阶段"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="简历链接"
              v-model="preference.resumeUrl"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="JD"
              v-model="preference.jobDescription"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="面试流程"
              v-model="preference.resumeJdQuestion"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
          <div class="flex xs12">
            <va-button @click="showResumeFlow = !showResumeFlow" class="mb-2">
              {{ showResumeFlow ? '收起 面试流程结构' : '展开 面试流程结构' }}
            </va-button>
            <vue-json-pretty
              v-if="showResumeFlow"
              :data="parsedResumeFlow"
              :show-line-number="true"
              :show-double-quotes="false"
              :deep="3"
            />
          </div>
        </div>
      </va-card>
    </div>

    <div class="flex xs10 offset--xs1">
      <va-card title="报告">
        <div class="row">
          <div class="flex  xs12">
            <va-input
              v-model="reportStatus"
              label="报告状态"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              v-model="report.tryTimes"
              label="请求生成报告次数"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="生成失败原因"
              v-model="report.generateFailReason"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
                label="分数"
                v-model="report.overallScore"
                disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
                label="等级"
                v-model="report.gradeLevel"
                disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
                label="雷达图"
                v-model="report.radarChart"
                disabled
            />
          </div>
          <div class="flex xs12">
            <va-input
              label="优点"
              v-model="report.advantage"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="缺点"
              v-model="report.shortcoming"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
          <div class="flex  xs12">
            <va-input
                label="各个维度报告"
                v-model="report.dimensionAnalysis"
                disabled
                type="textarea"
                min-rows=10
            />
          </div>
          <div class="flex xs12">
            <va-button @click="showDimensionDetail = !showDimensionDetail" class="mb-2">
              {{ showDimensionDetail ? '收起 维度详情结构' : '展开 维度详情结构' }}
            </va-button>
            <vue-json-pretty
              v-if="showDimensionDetail"
              :data="parsedDimensionAnalysis"
              :show-line-number="true"
              :show-double-quotes="false"
              :deep="3"
            />
          </div>

        </div>
      </va-card>
    </div>

  </div>
</template>

<script>

import { copyObject, formatTime, formatTimeWithSeconds } from '@/utils/common'
import interviewApi from '@/api/interview'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'


export default {
  components: {
    VueJsonPretty
  },

  data () {
    return {
      showJson: false,
      showResumeFlow: false,
      showDimensionDetail: false,
      surveyShow: false,
      subscriptionShow: false,
      pushRecordShow: false,
      conversation: '',
      basicInfo: {
        uid: '',
        nickname: '',
        startTime: 0,
        endTime: 0,
        status: 0,
        recordPath: '',
      },
      preference: {
        position: '',
        stages: '',
        resumeUrl: '',
        resumeJdQuestion: '',
        jobDescription: '',
      },
      report: {
        status: '',
        tryTimes: '',
        generateFailReason: '',
        overallScore: '',
        gradeLevel: '',
        radarChart: '',
        advantage: '',
        shortcoming: '',
        dimensionAnalysis: '',
      },
    }
  },
  created () {
    this.getUser()
  },
  computed: {
    parsedResumeFlow () {
      try {
        return typeof this.preference.resumeJdQuestion === 'string'
          ? JSON.parse(this.preference.resumeJdQuestion)
          : this.preference.resumeJdQuestion
      } catch (e) {
        return { error: 'Invalid resumeJdQuestion JSON' }
      }
    },
    parsedDimensionAnalysis () {
      try {
        return typeof this.report.dimensionAnalysis === 'string'
          ? JSON.parse(this.report.dimensionAnalysis)
          : this.report.dimensionAnalysis
      } catch (e) {
        return { error: 'Invalid dimensionAnalysis JSON' }
      }
    },
    parsedConversationList() {
      let raw = []
      try {
        raw = typeof this.conversation === 'string'
          ? JSON.parse(this.conversation)
          : this.conversation
      } catch (e) {
        return [{ error: 'Invalid conversation format' }]
      }

      // 初始解析（带原始 timestamp）
      const parsed = raw.map(str => {
        const [timestamp, speaker, text] = str.split('^_^')
        const ts = parseInt(timestamp)
        return {
          timestamp: ts,
          speaker,
          text,
          timeStr: formatTimeWithSeconds(ts)
        }
      })

      // 合并连续发言者 + 记录合并起止 timestamp
      const merged = []
      let lastSpeaker = null
      let lastEntry = null

      parsed.forEach(entry => {
        if (entry.speaker === lastSpeaker && lastEntry) {
          // 合并时更新内容和结束时间
          lastEntry.text += '\n' + entry.text
          lastEntry.endTimestamp = entry.timestamp
        } else {
          // 新一段，初始化 start/end 时间为当前
          const newEntry = {
            speaker: entry.speaker,
            text: entry.text,
            startTimestamp: entry.timestamp,
            endTimestamp: entry.timestamp
          }
          merged.push(newEntry)
          lastEntry = newEntry
          lastSpeaker = entry.speaker
        }
      })

      // 生成最终输出结构 + 计算 timeRange（使用下一个 startTimestamp）
      return merged.map((item, index) => {
        const startStr = formatTimeWithSeconds(item.startTimestamp)
        const next = merged[index + 1]
        const timeRange = next
          ? `${startStr} ~ ${formatTimeWithSeconds(next.startTimestamp)}`
          : `${startStr}` // 最后一段

        return {
          "time range": timeRange,
          "speaker": item.speaker,
          "content": item.text
        }
      })
    },
    roomStatus () {
      const roomStatus = this.basicInfo.status
      if (roomStatus === 1) {
        return '面试进行中'
      } else if (roomStatus === 2) {
        return '面试已结束'
      } else {
        return '已创建'
      }
    },
    reportStatus () {
      const roomStatus = this.report.status
      if (roomStatus === -1) {
        return '生成失败'
      } else if (roomStatus === 0) {
        return '可生成'
      } else if (roomStatus === 1) {
        return '生成中'
      } else if (roomStatus === 2) {
        return '成功'
      } else {
        return '生成失败'
      }
    },
    startTime () {
      const startTime = this.basicInfo.startTime
      if (!startTime) { return '-' }
      return formatTime(startTime)
    },
    endTime () {
      const endTime = this.basicInfo.endTime
      if (!endTime) { return '-' }
      return formatTime(endTime)
    },
  },
  methods: {
    toggleJsonShow () {
      this.showJson = !this.showJson
    },
    getUser () {
      const params = this.$route.params
      if (params.roomId != null) {
        // 通过id获取详情
        interviewApi.getInterview(params.roomId).then(response => {
          copyObject(response, this.basicInfo)
          this.basicInfo.startTime = formatTime(this.basicInfo.startTime)
          this.basicInfo.endTime = formatTime(this.basicInfo.endTime)

          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('userPreferenceDTO')) {
            copyObject(response.userPreferenceDTO, this.preference)
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('reportDTO')) {
            copyObject(response.reportDTO, this.report)
          }
          this.conversation = response.conversation
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
  },
}

</script>
